import React, { Fragment, useState, useEffect } from 'react';
import {FormControl , TextField, Grid , Box, Card, CardContent , Typography,CardActions,Button,Select,MenuItem } from '@mui/material/';
import InputLabel from '@mui/material/InputLabel';



import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


import { useParams } from 'react-router';

import RepportBySector from '../../components/reports/list_secteur';
import Autorize from '../../components/ui/autorize';

//https://react-data-table-component.netlify.app/?path=/docs/examples-filtering--filtering
function Reports() {

    
    const [errorAxios, setErrorAxios] = useState("false");
    const [autorize, setAutorize] = useState("false");

    const [dateDebut, setDateDebut] = useState("");
    const { myear } = useParams();
    const { myreport } = useParams();

    const [dateDebutTmp, setDateDebutTmp] = useState("");
    const [reportname, setreportname] = useState("");
    
    const [clublist, setList] = useState("");
    
    const [value, setValue] = React.useState(new Date());
    const [selectedDate, handleDateChange] = useState(new Date());
    const handleChange = (newValue) => {
      setValue(newValue);
    };


    

    useEffect(() => {

        if(autorize)
                {
                if(dateDebutTmp === "") {
                    setDateDebutTmp(myear);
                    setDateDebut(myear);       
                }

                if(reportname === "")        
                {
                    setreportname(myreport);
                }
            }
      

       }, [dateDebutTmp,reportname]);
           
    const handleChangeDebut = (newValue) => {
        var d = new Date(newValue);
        console.log(d.getFullYear());
        setDateDebut(d.getFullYear());
        setDateDebutTmp(newValue);
    };
  
    const handleChangeReports = (event) => {
        setreportname(event.target.value);
   };



      function mainHtml()
      {
  
          if(autorize)
          {
              return (<div>
                          <div style={{ width: '90%', margin: '3%' }}>
                       <Typography variant="h4" gutterBottom>
                        Rapport des membres mensuel
                       </Typography>
                    <Grid container direction="row" >
                        <Grid item xs={1}  direction="row" > 
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='fr'> 

                            <DatePicker id="MyYear"
                                views={['year']}
                                label="Année"
                                inputFormat="YYYY"
                                value={dateDebutTmp}
                                onChange={handleChangeDebut}
                                renderInput={(params) => <TextField {...params} />}
                                />

                            </LocalizationProvider>  
                        </Grid>
                      
                        <Grid item xs={2} container direction="row" > 
                          
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={reportname}
                                label="Rapport"
                                onChange={handleChangeReports}
                                >
                            
                                <MenuItem value='getReportEffectifMois'>Effectifs par mois</MenuItem>
                                <MenuItem value='getReportNouveauMembre'>Nouveaux membres par mois</MenuItem>
                                <MenuItem value='getReportMembreRadier'>Membres radiés par mois</MenuItem>

                             
                            </Select>

                          

                        </Grid>
                                                         
                    </Grid>

                                         
                    <RepportBySector key="sdsadsad" annee={dateDebut} reportname={reportname} />
                      

                  </div>
                      </div>);
          }
          else
              return "";
  
      }
    
      const callbackAutoriser = (index) => { // the callback. Use a better name      
        setAutorize(index);     
      };
        
    
        
//  {JSON.stringify(this.state.currentMember, null, 2) }     {Table} //
        return (
                <div>
                    <Autorize axiosError={errorAxios} callBackAutoriser={callbackAutoriser}/>

                    {mainHtml()}
                    
                </div>
            
        );
   
};

export default Reports;